module.exports = __webpack_public_path__ + "img/pt.04fa443d.svg";